import {Component, Input} from '@angular/core';
import {AuthService} from '../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent {
  name: string;
  @Input() title: string;
  @Input() subtitle: string;

  constructor(private authService: AuthService) {

  }

  isLoggedIn() {
    return this.authService.loggedIn();
  }

  getName() {
    return this.authService.getName();
  }
}
